// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeIndicatorExternalResourceForm_wrapper__t+AbI"};